// client/src/components/reputation/BadgeDisplay.js
import React, { useState, useEffect } from 'react';
import { Box, Tooltip, Typography, CircularProgress } from '@mui/material';
import axiosInstance from '../../axiosInstance';
import { useFeatureFlags } from '../../contexts/FeatureFlagsContext';

/**
 * Displays earned badges as emoji icons in a row.
 * Props: userId
 */
export default function BadgeDisplay({ userId }) {
  const { isFeatureEnabled } = useFeatureFlags();
  const [badges, setBadges] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isFeatureEnabled('enableReputationSystem') || !userId) { setLoading(false); return; }
    axiosInstance.get(`/reputation/${userId}/badges`)
      .then(res => setBadges(res.data))
      .catch(() => setBadges([]))
      .finally(() => setLoading(false));
  }, [userId, isFeatureEnabled]);

  if (!isFeatureEnabled('enableReputationSystem')) return null;
  if (loading) return <CircularProgress size={16} />;
  if (badges.length === 0) return null;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mt: 1 }}>
      {badges.map(b => (
        <Tooltip key={b._id} title={`${b.name}: ${b.description}`}>
          <Typography component="span" sx={{ fontSize: '1.25rem', cursor: 'default' }}>
            {b.icon}
          </Typography>
        </Tooltip>
      ))}
    </Box>
  );
}
